export default "img.loading_gif {\n  width: 30px;\n  height: auto;\n}"